import Ajv, {ErrorObject} from 'ajv';
import addFormats from 'ajv-formats';
import schema from './report-definition.schema.json';

const ajv = new Ajv({allErrors: true});
addFormats(ajv);
const validateFn = ajv.compile(schema as Record<string, unknown>);

export interface ValidationResult {
	valid: boolean;
	errors: string[];
}

/** Format a single ajv error. Keeps the offending property name for
 *  additionalProperties errors — ajv omits it from the default message. */
function formatError(e: ErrorObject): string {
	const path = e.instancePath || '/';
	const message = e.message ?? '';
	if (e.keyword === 'additionalProperties') {
		const prop = (e.params as {additionalProperty?: string}).additionalProperty;
		if (prop) {
			return `${path} ${message} (${prop})`.trim();
		}
	}
	return `${path} ${message}`.trim();
}

/** Validate a report definition against the schema. Never throws. */
export function validateReportDefinition(def: unknown): ValidationResult {
	const valid = validateFn(def) as boolean;
	const errors = (validateFn.errors ?? []).map(formatError);
	return {valid, errors};
}
